import {takeLatest} from "redux-saga/effects";
import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
  getFactureSouscriptionSaga,
  paiementSouscriptionSaga,
  tracePaymentInAccountSaga,
} from "./paiementSouscriptionSaga";

export default function* paiementSouscriptionWatcher() {
  yield takeLatest(
    ActionsTypes.GET_FACTURE_SOUSCRIPTION,
    getFactureSouscriptionSaga
  );
  yield takeLatest(
    ActionsTypes.PAIEMENT_SOUSCRIPTION,
    paiementSouscriptionSaga
  );
  yield takeLatest(
      ActionsTypes.TRACE_PAYMENT_IN_ACCOUNT,
      tracePaymentInAccountSaga
  );
}
